import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { FormItem, TextInput } from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { Divider } from 'antd';

export interface IUserAccountFormProps {}

export function UserAccountForm(props: IUserAccountFormProps) {
  const { t } = useTranslation();
  return (
    <>
      <Divider style={{ marginTop: 0 }}>
        {t('user-registration-form.top-title', 'Dati di accesso')}
      </Divider>
      <FormItem label={t('user-registration-form.email', 'Email')} name="email">
        <TextInput
          name="email"
          placeholder={t('user-registration-form.email', 'Email')}
          prefix={
            <UserOutlined aria-hidden="true" style={{ color: '#757575' }} />
          }
        />
      </FormItem>
      <FormItem
        label={t('user-registration-form.password', 'Password')}
        name="password"
      >
        <TextInput
          name="password"
          placeholder={t('user-registration-form.password', 'Password')}
          type="password"
          prefix={
            <LockOutlined aria-hidden="true" style={{ color: '#757575' }} />
          }
        />
      </FormItem>
      <FormItem
        label={t(
          'user-registration-form.password-confirm',
          'Conferma Password',
        )}
        name="confirmPassword"
      >
        <TextInput
          name="confirmPassword"
          placeholder={t(
            'user-registration-form.password-confirm',
            'Conferma Password',
          )}
          type="password"
          prefix={
            <LockOutlined aria-hidden="true" style={{ color: '#757575' }} />
          }
        />
      </FormItem>
    </>
  );
}
